export const setupLazyLoadImage = (emblaApi) => {
    const imagesInView = [];
    const slideNodes = emblaApi.slideNodes();
    const spinnerNodes = slideNodes.map((slideNode) =>
        slideNode.querySelector(".embla__lazy-load__spinner"),
    );
    const imageNodes = slideNodes.map((slideNode) =>
        slideNode.querySelector(".mi-gallery--carousel__image"),
    );

    const loadImageInView = (index) => {
        const imageNode = imageNodes[index];
        const slideNode = slideNodes[index];
        const spinnerNode = spinnerNodes[index];
        const src = imageNode.getAttribute("data-src");
        const srcSet = imageNode.getAttribute("data-srcset");

        imageNode.src = src;
        imageNode.srcset = srcSet;
        imagesInView.push(index);

        const onLoad = () => {
            slideNode.classList.add("embla__lazy-load--has-loaded");
            spinnerNode.parentElement?.removeChild(spinnerNode);
            imageNode.removeEventListener("load", onLoad);
        };
        imageNode.addEventListener("load", onLoad);
    };

    const loadImagesInView = () => {
        emblaApi
            .slidesInView()
            .filter((index) => !imagesInView.includes(index))
            .forEach(loadImageInView);
        return imagesInView.length === imageNodes.length;
    };

    const loadImagesInViewAndDestroyIfDone = (emblaApi, eventName) => {
        const loadedAll = loadImagesInView();
        if (loadedAll) emblaApi.off(eventName, loadImagesInViewAndDestroyIfDone);
    };

    return loadImagesInViewAndDestroyIfDone;
};
